import config from "@/constants/config"
import { timeLeft } from "@/utils/date.utils";

/**
 * Get to shop packs formatted items
 * @param Object packs - Packs to be formatted
 */
export const toShopPacks = (packs, visiblePackId) => packs.filter((pack) => pack.isActive)
    .map((pack) => ({
        id: pack.id,
        title: pack.Name,
        img: pack.ImagePath,
        max: pack.Max,
        maxPerUser: pack.Max_Per_User,
        hasMax: pack.Max >= 0,
        hasMaxPerUser: pack.Max_Per_User >= 0,
        hasTimeLimit: pack.hasTimeLimit === 1,
        isExpired: pack.hasTimeLimit === 1 && timeLeft(pack.TimeLeft).isExpired,
        hasDiscount: pack.hasDiscount === 1,
        hasLevels: hasLevels(pack.Min_Level, pack.Max_Level),
        isSameLevel: isSameLevel(pack.Min_Level, pack.Max_Level),
        currentPrice: getPrice({
            hasDiscount: pack.hasDiscount === 1,
            discountPrice: pack.Discount_Price,
            price: pack.Price
        }),
        price: pack.Price,
        discountPrice: pack.Discount_Price,
        timeLeft: pack.TimeLeft,
        categoryId: pack.Category,
        totalBought: pack.Total_Bought,
        minLevel: pack.Min_Level > -1 ? pack.Min_Level : 0,
        maxLevel: pack.Max_Level > -1 ? pack.Max_Level : 0,
        items: toItem(pack.items),
        isActive: pack.isActive,
        isSelected: visiblePackId && visiblePackId == pack.id
    }))
    .filter((item) => typeof item == "object")
    .reduce((list, current, index) => {
        const page = (list.length - 1) || -1;

        if (index % config.shopPacksPerPage && page != -1) {
            list[page].push(current)
        } else if (page > -1) {
            list[(page + 1)] = [current];
        } else if (page == -1 || page == 1) {
            list[1] = [current];
        }
        return list;
    }, [])


/**
 * Get price
 * @param number hasDiscount
 * @param number discountPrice
 * @param number price
 */
const getPrice = ({
    hasDiscount,
    discountPrice,
    price
}) => hasDiscount ? discountPrice : price;

const isSameLevel = (minLevel, maxLevel) => minLevel > -1 && maxLevel > -1 ? minLevel === maxLevel : false;

const hasLevels = (minLevel, maxLevel) => minLevel > -1 && maxLevel > -1;

export const getTotalPrice = (cart) => toCart(cart).reduce((price, currentItem) => price + currentItem.price, 0)

/**
 * @param Array items - The pack items
 */
export const toItem = (items) => items.map(({
    Amount: amount,
    Item_isLucky,
    item: {
        item_name
    }
}) => ({
    isBound: Item_isLucky === 1,
    amount,
    name: item_name
}))

/**
 * Get to cart formatted items
 * @param Array cart
 */
export const toCart = (cart) => {
    return cart.reduce((list, pack) => {
            const {
                title,
                id
            } = pack
            const cartItemExist = list.filter(({
                packId
            }) => packId == id);
            if (cartItemExist.length) {
                list = [
                    ...list.filter(({
                        packId
                    }) => packId != id),
                    {
                        packId: id,
                        amount: (cartItemExist[0].amount + 1),
                        title,
                        price: (getPrice(pack) + cartItemExist[0].price)
                    }
                ]
                return list;
            }
            list.push({
                packId: id,
                amount: 1,
                title,
                price: getPrice(pack)
            })
            return list;
        }, [])
        .sort(({
            priceA
        }, {
            priceB
        }) => priceA > priceB ? 1 : -1)
}
